import {parseForm} from '@jalik/form-parser';
import './utils';
import handle from "./client/2fa";

window.showView = (view) => {
    document.querySelectorAll('.auth-view').forEach(v => v.classList.remove('active'));
    document.getElementById(view + 'View').classList.add('active');
    history.replaceState(null, null, '#' + view);

    const resetForm = document.getElementById('resetForm') || null;
    const resetSuccess = document.getElementById('resetSuccess') || null;

    if (view !== 'reset' && (resetForm || resetSuccess)) {
        resetForm.style.display = 'block';
        resetSuccess.style.display = 'none';
    }
};

const initFromHash = () => {
    let h = location.hash.replace('#', '');
    if (['login', 'register', 'reset'].indexOf(h) !== -1) showView(h);
}

initFromHash();

window.togglePw = (btn) => {
    const inp = btn.parentElement.querySelector('input');
    if (inp.type === 'password') {
        inp.type = 'text';
        btn.textContent = '🙈'
    } else {
        inp.type = 'password';
        btn.textContent = '👁️'
    }
};

window.checkStrength = (password, input) => {
    const wrapper = input.closest('.input-wrap').nextElementSibling;
    const bars = wrapper.querySelectorAll('.pw-bar');
    const label = wrapper.nextElementSibling;

    let score = 0;

    if (password.length >= 8) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^a-zA-Z0-9]/.test(password)) score++;

    bars.forEach((bar, index) => {
        bar.className = 'pw-bar';
        if (index < score) {
            bar.classList.add(
                score <= 1 ? 'weak' :
                    score <= 2 ? 'medium' :
                        'strong'
            );
        }
    });

    if (password.length === 0) {
        label.textContent = '';
        label.className = 'pw-label';
    } else if (score <= 1) {
        label.textContent = 'Weak';
        label.className = 'pw-label weak';
    } else if (score <= 2) {
        label.textContent = 'Medium';
        label.className = 'pw-label medium';
    } else {
        label.textContent = 'Strong';
        label.className = 'pw-label strong';
    }
};

const simulateLoading = (btn, callback) => {
    btn.classList.add('loading');
    btn.disabled = true;
    setTimeout(() => {
        btn.classList.remove('loading');
        btn.disabled = false;
        callback()
    }, 1500);
}

const handlePassport = async (event) => {
    event.preventDefault();

    const form = event.target;
    const btn = form.querySelector('button[type="submit"]');
    const body = parseForm(form);
    simulateLoading(btn, async () => {
        const response = await requestWithCsrf(form.getAttribute('action'), body);

        const data = await response.json();

        if (response.status === 422) {
            messages(data, 'toast-top-right');
            if (form.getAttribute('name') === 'login') {
                form.reset();
            }
            return;
        }

        if (form.getAttribute('name') === 'reset-password') {
            document.location.href = data.redirect;
            return;
        }

        if (form.getAttribute('name') === 'resetPassword') {
            form.reset();

            if (typeof data.message !== 'undefined') {
                messages(data, 'toast-top-right');
            }

            const email = document.getElementById('resetEmail').value || 'your email';
            document.getElementById('resetForm').style.display = 'none';
            document.getElementById('resetSuccess').style.display = 'block';
            document.getElementById('resetEmailShow').textContent = email;
            return;
        }
        window.location.href = data.redirect;
    });
};

document.getElementById('twoFactorConfirm')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const success = await handle(e);
    if (success) {
        window.location.reload();
    }
});

document.getElementById('twoFactorForm')?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const form = e.target;
    const code = form.querySelector('input[name="code"]')

    const response = await requestWithCsrf(form.getAttribute('action'), {
        code: code.value
    });

    const data = await response.json();

    if (response.status !== 200) {
        messages({
            errors: true,
            message: data.message,
        }, 'toast-top-right');
        form.reset();
        code.focus();
        return;
    }

    window.location.href = data.redirect;
});

window.addEventListener('load', (event) => {
    const code = document.querySelector('input[name="code"]');
    if (code !== null) {
        code.focus();
    }
});

document.getElementById('loginForm')?.addEventListener('submit', await handlePassport);
document.getElementById('registrationForm')?.addEventListener('submit', await handlePassport);
document.getElementById('resetForm')?.addEventListener('submit', await handlePassport);
document.getElementById('reset-password')?.addEventListener('submit', await handlePassport);
document.addEventListener('hashchange', initFromHash);
